export default __webpack_public_path__ + "static/media/customer-girl.03372d60.png";